import styled from 'styled-components';

export const Container = styled.div`
  background: var(--white-darker);
  border-radius: 8px;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;

  > div {
    display: flex;
    min-width: 0;

    div {
      display: flex;
      flex-direction: column;
      margin-left: 10px;
      min-width: 0;

      span {
        font-size: 12px;
        color: var(--gray-9);
        font-weight: 500;
      }
      strong {
        font-size: 16px;
        font-weight: bold;
        color: var(--black-2);

        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
`;

export const Image = styled.img`
  background: var(--gray-d);
  border-radius: 8px;
  height: 40px;
  width: 40px;
  object-fit: cover;
`;

interface IBadge {
  color: string;
}

export const Badge = styled.span<IBadge>`
  font-size: 12px;
  font-weight: bold;
  color: ${props => props.color};
  position: absolute;
  top: 10px;
  right: 10px;
`;
